module.exports = __webpack_public_path__ + "img/main_wgoods.a74fd3e9.jpg";